import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';

import { Label, Input, ViewPasswordEye } from '../../AccountProfile/ProfileStyles';
import Asterix from '../../../assets/asterix.svg';
import { useTranslation } from 'react-i18next';

import './BiSwitch.css';

type SwitchProps = {
  label: string;
  setFormData: Function;
  formData: any;
  fieldKey: any;
  disableLabel?: boolean;
  id?: string;
  asterixFirst?: boolean;
  required?: boolean;
};
const BiSwitch = ({
  label,
  setFormData,
  formData,
  fieldKey,
  disableLabel,
  id,
  asterixFirst,
  required
}: SwitchProps) => {
  const { t } = useTranslation();

  const value = formData[fieldKey] === 'true';
  const [toggle, setToggle] = useState(value);

  const switchToggle = () => {
    setToggle(!toggle);
  };
  const getBgColor = () => {
    if (toggle) {
      return 'bg-[#0074e0]';
    }
    return 'bg-[#BFBFBF]';
  };

  const getTogglePosition = () => {
    if (toggle) {
      return 'right-0.5';
    }
    return 'left-0.5';
  };

  useEffect(() => {
    //onChange(toggle);
    setFormData({ ...formData, [fieldKey]: toggle.toString() });
  }, [toggle]);

  return (
    <>
      {!disableLabel ? (
        <Label htmlFor={id}>
          {asterixFirst && required ? <Image src={Asterix} className="mr-1" /> : ''}
          {t(label)}
        </Label>
      ) : (
        ''
      )}
      <div className="flex items-center">
        <div
          className={
            'switch relative mr-2 h-5 w-11 cursor-pointer rounded-2xl transition delay-150 ease-in-out ' +
            getBgColor()
          }
          onClick={switchToggle}
        >
          <div
            className={
              'toggle-button absolute h-4 w-4 rounded-2xl bg-[#ffffff] ' + getTogglePosition()
            }
          ></div>
        </div>
        {toggle ? 'TRUE' : 'FALSE'}
      </div>
    </>
  );
};

const Image = styled.img`
  width: 8px;
  height: 8px;
`;
export default BiSwitch;
